module.exports = __webpack_public_path__ + "static/media/before-choose.34aac8ee.png";